module.exports = __webpack_public_path__ + "img/upload.e5fcd066.png";